import { CopyIconButton } from "shared/components/CopyIconButton";

export const CopyableContactRow = ({
  value,
  displayValue,
  copyAriaLabel
}: {
  value: string;
  displayValue?: string;
  copyAriaLabel: string;
}) => {
  return (
    <div className="flex items-center gap-2 min-w-0">
      <span className="text-sm font-medium text-content-400 truncate">
        {displayValue || value}
      </span>

      <CopyIconButton
        value={value}
        idleAriaLabel={copyAriaLabel}
        strokeWidth={1}
        stopPropagation
      />
    </div>
  );
};
